const items = [
	{
		id: 1,
		key: 1,
		name: "status.active"
	},
	{
		id: 2,
		key: -1,
		name: "status.rejected"
	},
	{
		id: 0,
		key: 0,
		name: "status.waiting"
	}
];

export default items;